"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MediaCell = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importDefault(require("react"));
var simple_react_lightbox_1 = __importStar(require("simple-react-lightbox"));
var ImageListMore_1 = require("../../molecules/ImageListMore");
/**
 * @deprecated
 */
exports.MediaCell = react_1.default.memo(function (_a) {
    var _b;
    var value = _a.value;
    var videoFormats = ['mp4', 'mov', 'wmv', 'avi', 'mkv', 'flv'];
    var downloadFile = function (data, object) {
        var file = data[object.id];
        if (videoFormats.includes(file.type)) {
            var a = document.createElement('a');
            a.href = file.original.link;
            a.target = '_blank';
            a.download = "video-".concat(object.id, ".").concat(file.type);
            a.click();
        }
    };
    var callbacks = function (data) { return ({
        onSlideChange: function (object) { var _a; return downloadFile(data, (_a = object === null || object === void 0 ? void 0 : object.slides) === null || _a === void 0 ? void 0 : _a.current); },
        onLightboxOpened: function (object) { return downloadFile(data, object === null || object === void 0 ? void 0 : object.currentSlide); },
    }); };
    return ((0, jsx_runtime_1.jsx)(simple_react_lightbox_1.default, { children: (0, jsx_runtime_1.jsx)(simple_react_lightbox_1.SRLWrapper, __assign({ callbacks: callbacks(value === null || value === void 0 ? void 0 : value.items) }, { children: (0, jsx_runtime_1.jsx)(ImageListMore_1.ImageListMore, { justifyContent: "flex-start", size: 40, maxNumberOfItems: 3, items: ((_b = value.items) === null || _b === void 0 ? void 0 : _b.map(function (item) {
                    var _a;
                    var thumb = (_a = item === null || item === void 0 ? void 0 : item.thumbnail) === null || _a === void 0 ? void 0 : _a.link;
                    return {
                        src: thumb,
                        srcSet: thumb,
                        sizes: '600px',
                    };
                })) || [] }) })) }));
});
